import querystring from 'querystring'

import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

import Container from './Container'
import SignIn from './SignIn'
import ConfirmResetPassword from './ConfirmResetPassword'
import PasswordForgot from './PasswordForgot'
import ResetPasswordSuccess from './ResetPasswordSuccess'
import MfaSetup from './MfaSetup'
import MfaVerify from './MfaVerify'
import AccountDisabled from './AccountDisabled'
import ForceChangePassword from './ForceChangePassword'

const authErrorMapping = {
  'Username cannot be empty': 'UsernameEmpty',
  'Password cannot be empty': 'PasswordEmpty',
  'Confirmation code cannot be empty': 'ConfirmationCodeEmpty',
}

const components = {
  signIn: SignIn,
  confirmResetPassword: ConfirmResetPassword,
  passwordForgot: PasswordForgot,
  resetPasswordSuccess: ResetPasswordSuccess,
  mfaSetup: MfaSetup,
  mfaVerify: MfaVerify,
  accountDisabled: AccountDisabled,
  forceChangePassword: ForceChangePassword,
  loggedIn: () => <div data-testid="loggedin-title">Logged in</div>,
}

const Login = ({ redirectUrl }) => {
  const [view, setView] = useState('signIn')
  const [error, setError] = useState()
  const [loginError, setLoginError] = useState()
  const [fetching, setFetching] = useState(false)
  // TODO verify if this required
  const [, setFrom] = useState()
  const [customParams, setCustomParams] = useState()
  const [state, setState] = useState({
    email: '',
    password: '',
    // email: 'davide.fiorello@remotamente.it',
    // password: 'XXXXXXXX',
    optCode: '',
    optCode1: '',
    rememberMe: false,
    passwordConfirm: '',
    newPassword: '',
    newPasswordConfirm: '',
    acceptPrivacyAndTerms: false,
    acceptCommercials: false,
  })
  const location = useLocation()

  const queryParams = useMemo(
    () => querystring.parse((location.search.split('?') || [null, ''])[1]),
    [location]
  )

  useEffect(() => {
    if (queryParams.error) {
      setLoginError(queryParams.error)
    }
  }, [queryParams?.error, setLoginError])

  useEffect(() => {
    setFetching(false)
  }, [view])

  useEffect(() => {
    if (queryParams.from) {
      setFrom(queryParams.from)
      setCustomParams(
        Object.keys(queryParams)
          .map(
            (k) =>
              `${encodeURIComponent(k)}=${encodeURIComponent(queryParams[k])}`
          )
          .join('&')
      )
    }
  }, [queryParams])

  const Component = components[view]
  return (
    <Container>
      <Component
        redirectUrl={redirectUrl}
        setView={setView}
        state={state}
        setState={setState}
        error={error}
        loginError={loginError}
        setLoginError={setLoginError}
        setError={setError}
        fetching={fetching}
        setFetching={setFetching}
        authErrorMapping={authErrorMapping}
        customUrlParams={customParams}
      />
    </Container>
  )
}

export default Login
